import { ReactNode } from 'react'
import cx from 'classnames'

export default ({ title, margin }: { title: ReactNode, margin?: string }) => (
  <h2
    className={cx('black fw6 lighter pt2 f3 mt0-t ', {
      [margin]: margin,
      'mt8 mb8 mt4-m': !margin
    })}
  >{title}
  </h2>
)
